import React from 'react';
import { Document, Font } from '@react-pdf/renderer';
import { fonts } from 'stylesheets';

import {
  Page,
  Section,
} from './styles';

import Header from './Header';
import SectionDetails from './SectionDetails';
import SectionQuotes from './SectionQuotes';
import SectionTaskDetails from './SectionTaskDetails';
import SectionPhotos from './SectionPhotos';

const ReportTask = ({ quotes, taskDetail, company }) => (
  <Document>
    <Page size="A4">
      <Section>
        <Header company={company} />
      </Section>

      <Section background="#F07E31">
        <SectionDetails taskDetail={taskDetail} />
      </Section>

      <Section>
        <SectionQuotes quotes={quotes} />
      </Section>
    </Page>

    <Page>
      <Section>
        <Header company={company} />
      </Section>

      <Section background="#F07E31" height="100%">
        <SectionTaskDetails questions={taskDetail.fields} />
      </Section>
    </Page>

    {
        taskDetail.photos && (
          <Page>
            <Section>
              <Header company={company} />
            </Section>
            <Section background="#F07E31" height="100%">
              <SectionPhotos photos={taskDetail.photos} />
            </Section>
          </Page>
        )
      }
  </Document>
);

export default ReportTask;


Font.register({
  family: fonts.primary,
  fonts: [
    {
      src: `http${process.env.NODE_ENV === 'production' ? 's' : ''
      }://fonts.gstatic.com/s/quicksand/v6/Ngv3fIJjKB7sD-bTUGIFCA.ttf`,
    },
    {
      src: `http${process.env.NODE_ENV === 'production' ? 's' : ''
      }://fonts.gstatic.com/s/quicksand/v6/32nyIRHyCu6iqEka_hbKsi3USBnSvpkopQaUR-2r7iU.ttf`,
      fontWeight: 700,
    },
  ],
});
